import { createTheme } from "@material-ui/core/styles";

const MyTheme = createTheme({
  palette: {
    primary: { main: "#69a5e3", contrastText: "#f5f5f5" }, //blue
    secondary: { main: "#df4343", contrastText: "#f5f5f5" }, //red
    green: { color: "#70e359" },
    white: { color: "#fff" },
  },
});

export default MyTheme;
